import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core'

@Directive({
  selector: '[appAlert]',
  standalone: true,
})
export class AlertDirective implements OnChanges {
  @Input() show: boolean
  @Input() durationSec: number = 4
  @Output() showChange = new EventEmitter<boolean>()

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show'].currentValue === true) {
      this.el.nativeElement.className = this.el.nativeElement.className.replace('!hidden', '')

      setTimeout(() => {
        this.show = false
        this.el.nativeElement.classList.add('!hidden')
        this.showChange.emit(this.show)
      }, this.durationSec * 1000)
    }
  }
}
